import { useDocumentTitle } from '../../../hooks/useDocumentTitle';

interface PageContainerTitleProps {
  title: string;
  description?: string;
  /**
   * 부제 색상 (크기·굵기는 동일)
   * - basic: 검정. 안내 문구형 부제 (예: 코스 찾기, 커뮤니티 찾기)
   * - accent: 보라색(purple5). 강조 문구형 부제 (예: 코스 카테고리, 회원 후기)
   */
  variant?: 'basic' | 'accent';
}

/**
 * 페이지 상단 제목 + 부제 (h1). 페이지당 하나만 사용
 *
 * PageContainer 안에서 사용 (예: 코스 찾기, 커뮤니티 찾기, 코스 카테고리, 회원 후기)
 * - PageContainer는 xl 미만 좌우 여백이 없어서 이 컴포넌트가 직접 가짐 (px-[20px] xl:px-0)
 * - NormalPage 안에서는 NormalPageTitle 사용 (여기서 쓰면 xl 미만 좌우 여백이 중복됨)
 */
export const PageContainerTitle = ({
  title,
  description,
  variant = 'basic',
}: PageContainerTitleProps) => {
  useDocumentTitle(title);

  return (
    <header className="px-[20px] pt-8 xl:px-0">
      <h1 className="text-title_h2 text-black xl:text-title_h1">{title}</h1>
      {description && (
        <p
          className={`pt-4 text-title_h4 ${
            variant === 'accent' ? 'text-purple5' : 'text-black'
          }`}
        >
          {description}
        </p>
      )}
    </header>
  );
};
